import React from 'react';
import { THeaderBlockData } from '../types';
import Typo from '../../Typography';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, THeaderHighlightBlockData } from '../../Highlight/types';

export const renderHeader = (
  { level, text, alignment = 'left' }: THeaderBlockData,
  highlightData?: THeaderHighlightBlockData,
) => {
  const { text: highlightText } = highlightData || {};
  return (
    <Typo
      tag={level === 1 ? 'h2' : `h${level}`}
      variant={`article-h${level}`}
      style={{ textAlign: alignment }}
      {...getHighlightSelectionTipProps(HighlightSelectionHint.Text)}
    >
      {parseWithoutNonBreakingSpaces(withHighlightAsText(text, highlightText))}
    </Typo>
  );
};
